import axios from 'axios'
import utils from '@/utils'
import router from '@/router'
import {Message} from 'element-ui';

axios.defaults.timeout = 150000; // 响应时间

axios.defaults.baseURL = ''; // 配置接口地址

axios.defaults.withCredentials = true;// 验证码验证

// 是否是价格类
function validePirce(val) {
  const priceArray = ['buyPrice', 'deliveryPrice', 'lowestPrice', 'paBuyPrice', 'paDeliveryPrice', 'paLowestPrice', 'paPlusVipPrice',
    'paRetailPrice', 'paTradePrice', 'paVipPrice', 'plusVipPrice', 'retailPrice', 'tradePrice', 'vipPrice'];
  if (priceArray.includes(val)) {
    return true
  } else {
    return false
  }
}


// 是否是数量的类型
function valideMount(val) {
  const mountArray = ['giveGoodsNum', 'goodsNum', 'inventoryNum', 'highInventory', 'lowInventory'];
  if (mountArray.includes(val)) {
    return true
  } else {
    return false
  }
}

// POST传参序列化(添加请求拦截器)
axios.interceptors.request.use((config) => {
  return config;
}, (error) => {
  console.log('错误的传参')
  console.log(error)
  return Promise.reject(error);
});

// 返回状态判断(添加响应拦截器)
axios.interceptors.response.use((res) => {
  // 对响应数据做些事
  if (!res.data || !res.data.success) {
    return Promise.resolve(res);
  }
  return res;
}, (error) => {
  if (error.response) {
    switch (error.response.status) {
      case 401:
        localStorage.clear();
        router.push({path: '/login'});
        return Promise.resolve({code: 500, msg: '无response！'});
      case 400:
      case 422:
        return Promise.resolve(error.response);
    }
  }
});

function setUserParams(params) {
  let user = localStorage.getItem('SYSUSER');
  if (typeof (params) === 'object' && user) {
    user = JSON.parse(user);
    if (!params.storeId) {
      params.storeId = user.storeId;
    }
    params.merchantId = user.merchantId;
    return params;
  } else {
    return params;
  }
}

// 序列化加密添加token
function serializeParam(data) {
  let key = utils.getSessionID();
  if (!key) {
    return data;
  }
  let params = null;
  if (typeof (data) === 'string') {
    params = utils.stringToJSON(data);
  } else {
    params = utils.deepClone(data);
  }
  let par = {};
  Object.keys(params).map(key => {
    if (params[key] != null && params[key] != undefined) {
      par[key] = params[key]
    }
  });
  params = par;
  // 转成字符
  let paramsStr = utils.JSONToString(utils.sortASCII(params));
  paramsStr += '&key=' + key;
  // md5加密 并转成大写
  let md5Str = utils.md5(utils.stringToBytes(paramsStr)).toUpperCase();
  params.sign = md5Str;
  if (typeof (data) === 'string') {
    return utils.JSONToString(params);
  }
  return params;
}

// 返回一个Promise(发送post请求)
function fetchPost(url, params = {}, headers) {
  params = serializeParam(setUserParams(params));

  return new Promise((resolve, reject) => {

    axios.post(url, params, {headers: headers})
      .then(response => {
        successDataReturn(response, resolve, reject);
      }, err => {
        console.log(err)
        reject(err);
      })
      .catch((error) => {
        console.log(err)
        reject(error)
      })
  })
}

function checkMount() {
  /**
   * 价格和数量参数判断
   */
  let priceFlag = false
  let mountFlag = false
  for (let key in params) {
    if (validePirce(key)) {
      if (params[key] > 99999.99) {
        priceFlag = true
      }
    }
    if (valideMount(key)) {
      if (params[key] > 9999.999) {
        mountFlag = true
      }
    }
  }
  if (mountFlag) {
    Message({
      type: 'error',
      message: '数量相关不能超过9999.999'
    })
    reject(new Error('数量相关不能超过9999.999'))
  }
  if (priceFlag) {
    Message({
      type: 'error',
      message: '价格不能超过99999.99'
    })
    reject(new Error('价格不能超过99999.99'))
  }
}

// 返回一个Promise(发送put请求)
function fetchPut(url, params = {}, headers) {
  return new Promise((resolve, reject) => {
    axios.put(url, params, {headers: headers})
      .then(response => {
        successDataReturn(response, resolve, reject);
      }, err => {
        reject(err);
      })
      .catch((error) => {
        reject(error)
      })
  })
}

// 返回一个Promise(发送Delete请求)
function fetchDelete(url, params = {}, headers) {
  return new Promise((resolve, reject) => {
    axios.delete(url, {params: params}, {headers: headers})
      .then(response => {
        successDataReturn(response, resolve, reject);
      }, err => {
        reject(err);
      })
      .catch((error) => {
        reject(error)
      })
  })
}

/// /返回一个Promise(发送get请求)
function fetchGet(url, params = {}, headers) {
  let searchParams = {};
  if (url.split('?').length > 1) {
    searchParams = utils.stringToJSON(url.split('?')[1]);
    url = url.split('?')[0];
  }
  params = {...searchParams, ...params};
  params = serializeParam(setUserParams(params));
  return new Promise((resolve, reject) => {
    axios.get(url, {params: params}, {headers: headers})
      .then(response => {
        successDataReturn(response, resolve, reject);
      }, err => {
        reject(err)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

function fetchPostBlob(url, params = {}, headers) {
  params = serializeParam(setUserParams(params));
  return new Promise((resolve, reject) => {
    axios.post(url, params, {headers: headers, responseType: 'blob'})
      .then(response => {
        successDataReturn(response, resolve, reject);
      }, err => {
        console.log(err)
        reject(err);
      })
      .catch((error) => {
        console.log(err)
        reject(error)
      })
  })
}

function successBlobDataReturn(response, resolve, reject) {
  if (response && response.status === 200) {
    resolve(response);
  } else if (response && response.status != 200 && response.data) {
    response.data.msg = (response.data && (response.data.msg || response.data.errorMsg)) || '请求失败';
    response.data.code = response.status;
    resolve(response.data);
  } else {
    reject({code: 500, msg: '无response！'});
  }
}

function PostBlob(url, params = {}, headers) {
  params = serializeParam(setUserParams(params));
  return new Promise((resolve, reject) => {
    axios.post(url, params, {headers: headers, responseType: 'arraybuffer'})
      .then(response => {
        successBlobDataReturn(response, resolve, reject);
      }, err => {
        console.log(err)
        reject(err);
      })
      .catch((error) => {
        console.log(err)
        reject(error)
      })
  })
}

// 流转化为图片src
function fetchPostStream(url, params = {}, headers) {
  params = serializeParam(setUserParams(params));
  return new Promise((resolve, reject) => {
    axios.post(url, params, {headers: headers, responseType: 'arraybuffer'})
      .then(response => {
        successDataReturn(response, resolve, reject);
      }, err => {
        console.log(err)
        reject(err);
      })
      .catch((error) => {
        console.log(err)
        reject(error)
      })
  })
}

// 返回一个Promise(发送post请求)
function fetchPostInUpload(url, params = {}, headers) {
  return new Promise((resolve, reject) => {
    axios.post(url, params, {headers: headers})
      .then(response => {
        successDataReturn(response, resolve, reject);
      }, err => {
        console.log(err)
        reject(err);
      })
      .catch((error) => {
        console.log(err)
        reject(error)
      })
  })
}

function fetchPostImportExport(url, params = {}, headers) {
  return new Promise((resolve, reject) => {
    axios.post(url, params, {headers: headers, responseType: 'blob'})
      .then(response => {
        successDataReturn(response, resolve, reject);
      }, err => {
        console.log(err)
        reject(err);
      })
      .catch((error) => {
        console.log(err)
        reject(error)
      })
  })
}

function successDataReturn(response, resolve, reject) {
  if (response && response.status == 200) {
    if (response.data.code === 200) {
      resolve(response.data);
    } else {
      response.data.msg = (response.data && response.data.errorMsg) || '请求失败';
      resolve(response.data);
    }
  } else if (response && response.status != 200 && response.data) {
    response.data.msg = (response.data && (response.data.msg || response.data.errorMsg)) || '请求失败';
    response.data.code = response.status;
    resolve(response.data);
  } else {
    reject({code: 500, msg: '无response！'});
  }
}

function fetchPostGoodsExport(url, params = {}, headers) {
  return new Promise((resolve, reject) => {
    axios.post(url, params, {headers: headers})
      .then(response => {
        successDataReturn(response, resolve, reject);
      }, err => {
        console.log(err)
        reject(err);
      })
      .catch((error) => {
        console.log(error)
        reject(error)
      })
  })
}

function fetchPostGoodsExportBlob(url, params = {}, headers) {
  return new Promise((resolve, reject) => {
    axios.post(url, params, {headers: headers, responseType: 'arraybuffer'})
      .then(response => {
        successBlobDataReturn(response, resolve, reject);
      }, err => {
        console.log(err);
        reject(err);
      })
      .catch((error) => {
        console.log(error);
        reject(error)
      })
  })
}

export default {
  fetchPost,
  fetchGet,
  fetchPut,
  fetchDelete,
  fetchPostBlob,
  fetchPostStream,
  fetchPostInUpload,
  fetchPostImportExport,
  fetchPostGoodsExport,
  PostBlob,
  fetchPostGoodsExportBlob
}



// WEBPACK FOOTER //
// ./src/services/axios.js